import {
  DataTableSource,
  TableRow,
  type DataTablePageOptions,
  type DataTablePageReq,
} from "@carbon6/c6-frontend-design";
import {
  listStorageCleanupTargets,
  listInvalidEpisodes,
  type StorageCleanupTarget,
  type InvalidEpisode,
  type InvalidEpisodeState,
  type CleanupTargetStatus,
} from "@/api/adminStorage";
import { adminOperationError } from "@/app/adminOperationError";

export class CleanupTargetRow extends TableRow {
  constructor(readonly target: StorageCleanupTarget) {
    super(null);
  }
  get status() {
    return this.target.status;
  }
  get markers() {
    return this.target.eligible;
  }
  get bytes() {
    return this.target.freed_bytes_estimate;
  }
  get job() {
    return this.target.job_status;
  }
  getRowId() {
    return this.target.dataset_uuid;
  }
  canShow() {
    return true;
  }
  canSelect() {
    return true;
  }
}
export class CleanupTargetSource extends DataTableSource<CleanupTargetRow> {
  constructor(
    private readonly status: CleanupTargetStatus | undefined,
    page: number,
    onSelectionChange: () => void,
  ) {
    super({
      initialPage: page,
      initialPageSize: 20,
      resolveErrorMessage: adminOperationError,
      onSelectionChange,
    });
  }
  protected override async onPage(req: DataTablePageReq, { signal }: DataTablePageOptions) {
    const response = await listStorageCleanupTargets({ ...req, status: this.status }, { signal });
    return { ...response, rows: response.items.map((target) => new CleanupTargetRow(target)) };
  }
}
export class InvalidEpisodeRow extends TableRow {
  constructor(readonly episode: InvalidEpisode) {
    super(null);
  }
  get datasets() {
    return this.episode.datasets;
  }
  get accepted() {
    return this.episode.accepted_invalid;
  }
  get action() {
    return this.episode.uuid;
  }
  getRowId() {
    return this.episode.uuid;
  }
  canShow() {
    return true;
  }
  canSelect() {
    return false;
  }
}
export class InvalidEpisodeSource extends DataTableSource<InvalidEpisodeRow> {
  constructor(
    private readonly state: InvalidEpisodeState,
    page: number,
  ) {
    super({ initialPage: page, initialPageSize: 20, resolveErrorMessage: adminOperationError });
  }
  protected override async onPage(req: DataTablePageReq, { signal }: DataTablePageOptions) {
    const response = await listInvalidEpisodes({ ...req, state: this.state }, { signal });
    return { ...response, rows: response.items.map((episode) => new InvalidEpisodeRow(episode)) };
  }
}
